import React from 'react'
import style from './NavigatePage.module.scss'
import main from '../../images/main.png'
import gantt from '../../images/gantt.png'
import { Link } from 'react-router-dom'

const NavigatePage = () => {
  const systems = [
    {
      key: 'main',
      title: 'Главная',
      link: '/main',
      image: main
    },
    {
      key: 'gantt',
      title: 'Диаграмма активности',
      link: '/gantt',
      image: gantt
    }
  ]
  return (
    <div className={style.wrapper}>
      {systems.map((item) => {
        return (
          <Link to={item.link} className={style.item} key={item.key}>
            <div
              className={style.images}
              style={{
                backgroundImage: `url(${item.image})`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat'
              }}></div>
            <div className={style.title}>{item.title}</div>
          </Link>
        )
      })}
    </div>
  )
}

export default NavigatePage
